import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { Contact, Customer, InventoryTransaction, MetalsHardwareItem, MetalsHardwareItemType, MetalsLaserMaterial, MetalsProduct, MetalsProductBillOfMaterialsLineItem, MetalsProductSetup, MetalsProductType, MetalsProductVersion, MetalsVendorHardwareData, Resource, SaveStatus, StampingStation, StampingTask, Tag, ToolRoomMachine } from "@prism/prism-shared";

export const LoadHardwareItems = createActionGroup({
    source: 'Metals LoadHardwareItems',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ hardwareItems: MetalsHardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemsByType = createActionGroup({
    source: 'Metals LoadHardwareItemsByType',
    events: {
        'Initial': props<{ hardwareItemType: MetalsHardwareItemType }>(),
        'Success': props<{ hardwareItems: MetalsHardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMetalsLaserMaterials = createActionGroup({
    source: 'Metals LoadMetalsLaserMaterials',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ metalsLaserMaterials: MetalsLaserMaterial[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemById = createActionGroup({
    source: 'Metals LoadHardwareItemById',
    events: {
        'Initial': props<{ hardwareItemId: string; }>(),
        'Success': props<{ hardwareItem: MetalsHardwareItem; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemsByIds = createActionGroup({
    source: 'Metals LoadHardwareItemsByIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[] }>(),
        'Success': props<{ hardwareItems: MetalsHardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetHardwareItem = createActionGroup({
    source: 'Metals SetHardwareItem',
    events: {
        'Initial': props<{ hardwareItem: MetalsHardwareItem; }>(),
        'Success': props<{ hardwareItem: MetalsHardwareItem; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetVendorHardwareData = createActionGroup({
    source: 'Metals SetVendorHardwareData',
    events: {
        'Initial': props<{ vendorHardwareData: MetalsVendorHardwareData; }>(),
        'Success': props<{ vendorHardwareData: MetalsVendorHardwareData; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadContacts = createActionGroup({
    source: 'Metals LoadContacts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ contacts: Contact[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadContactById = createActionGroup({
    source: 'Metals LoadContactById',
    events: {
        'Initial': props<{ contactId: string; }>(),
        'Success': props<{ contact: Contact; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetContact = createActionGroup({
    source: 'Metals SetContact',
    events: {
        'Initial': props<{ contact: Contact; }>(),
        'Success': props<{ contact: Contact; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareData = createActionGroup({
    source: 'Metals LoadVendorHardwareData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ vendorHardwareData: MetalsVendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareDataByHardwareItemId = createActionGroup({
    source: 'Metals LoadVendorHardwareDataByHardwareItemId',
    events: {
        'Initial': props<{ hardwareItemId: string; }>(),
        'Success': props<{ vendorHardwareData: MetalsVendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareDataByHardwareItemIds = createActionGroup({
    source: 'Metals LoadVendorHardwareDataByHardwareItemIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[]; }>(),
        'Success': props<{ vendorHardwareData: MetalsVendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadTags = createActionGroup({
    source: 'Metals LoadTags',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tags: Tag[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});



export const SetHardwareInventoryTransaction = createActionGroup({
    source: 'Metals SetHardwareInventoryTransaction',
    events: {
        'Initial': props<{ hardwareId: string, qtyChange: number; comment: string; }>(),
        'Success': props<{ transaction: InventoryTransaction; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRecentHardwareInventoryTransactions = createActionGroup({
    source: 'Metals LoadRecentHardwareInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});




export const SetProduct = createActionGroup({
    source: 'Metals SetProduct',
    events: {
        'initial': props<{ product: MetalsProduct; }>(),
        'success': props<{
            product: MetalsProduct;
        }>(),
        'failure': props<{ error: any; }>(),
    }
});

export const SetProductVersion = createActionGroup({
    source: 'Metals SetProductVersion',
    events: {
        'initial': props<{ productVersion: MetalsProductVersion; }>(),
        'success': props<{
            productVersion: MetalsProductVersion;
        }>(),
        'failure': props<{ error: any; }>(),
    }
});


export const LoadProducts = createActionGroup({
    source: 'Metals LoadProducts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ products: MetalsProduct[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedProductVersions = createActionGroup({
    source: 'Metals LoadReleasedProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedProductVersions: MetalsProductVersion[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedAndDraftProductVersions = createActionGroup({
    source: 'Metals LoadReleasedAndDraftProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedAndDraftProductVersions: MetalsProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadProductById = createActionGroup({
    source: 'Metals LoadProductById',
    events: {
        'Initial': props<{ productId: string; }>(),
        'Success': props<{ product: MetalsProduct; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductsByIds = createActionGroup({
    source: 'Metals LoadProductsByIds',
    events: {
        'Initial': props<{ productIds: string[]; }>(),
        'Success': props<{ products: MetalsProduct[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductVersionsByIds = createActionGroup({
    source: 'Metals LoadProductVersionsByIds',
    events: {
        'Initial': props<{ productVersionIds: string[] }>(),
        'Success': props<{ productVersions: MetalsProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const ClearState = createAction(
    'Metals ClearState',
)


export const SetBillOfMaterialsLineItems = createActionGroup({
    source: 'Metals SetBillOfMaterialsLineItems',
    events: {
        'Initial': props<{ lineItems: MetalsProductBillOfMaterialsLineItem[]; }>(),
        'Success': props<{ lineItems: MetalsProductBillOfMaterialsLineItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadActiveStampingTasks = createActionGroup({
    source: 'Metals LoadActiveStampingTasks',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tasks: StampingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadStampingStations = createActionGroup({
    source: 'Plastics LoadStampingStations',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ stations: StampingStation[] }>(),
        'Failure': props<{ error: any }>(),
    }
});


export const SetStampingStation = createActionGroup({
    source: 'Metals SetStampingStation',
    events: {
        'Initial': props<{ station: StampingStation }>(),
        'Success': props<{ station: StampingStation }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetStampingTask = createActionGroup({
    source: 'Metals SetStampingTask',
    events: {
        'Initial': props<{ task: StampingTask }>(),
        'Success': props<{ task: StampingTask }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductSetups = createActionGroup({
    source: 'Metals LoadProductSetups',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ productSetups: MetalsProductSetup[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductSetupById = createActionGroup({
    source: 'Metals LoadProductSetupById',
    events: {
        'Initial': props<{ productSetupId: string }>(),
        'Success': props<{ productSetup: MetalsProductSetup }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProductSetup = createActionGroup({
    source: 'Metals SetProductSetup',
    events: {
        'Initial': props<{ productSetup: MetalsProductSetup }>(),
        'Success': props<{ productSetup: MetalsProductSetup }>(),
        'Failure': props<{ error: any }>(),
    }
});

/** Merge a product setup into the store without touching loadingState. */
export const UpsertProductSetupLocal = createAction(
    '[Metals] Upsert Product Setup Local',
    props<{ productSetup: MetalsProductSetup }>(),
);

export const DeleteProductSetup = createActionGroup({
    source: 'Metals DeleteProductSetup',
    events: {
        'Initial': props<{ productSetupId: string }>(),
        'Success': props<{ productSetupId: string }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadToolRoomMachines = createActionGroup({
    source: 'Metals LoadToolRoomMachines',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ machines: ToolRoomMachine[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetToolRoomMachine = createActionGroup({
    source: 'Metals SetToolRoomMachine',
    events: {
        'Initial': props<{ machine: ToolRoomMachine }>(),
        'Success': props<{ machine: ToolRoomMachine }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const DeleteToolRoomMachine = createActionGroup({
    source: 'Metals DeleteToolRoomMachine',
    events: {
        'Initial': props<{ machineId: string }>(),
        'Success': props<{ machineId: string }>(),
        'Failure': props<{ error: any }>(),
    }
});

// export const SetCuttingTasks = createActionGroup({
//     source: 'Metals SetCuttingTasks',
//     events: {
//         'Initial': props<{ tasks: MetalsCuttingTask }>(),
//         'Success': props<{ tasks: MetalsCuttingTask }>(),
//         'Failure': props<{ error: any }>(),
//     }
// });
